import React, { useState, useRef } from "react";
import BackgroundImageFromUrl from "../../components/parseImage/BackgroundImageFromUrl";
import ScrollRef from "../../detail-components/ScrollRef";
import jsonParser from "../helper/jsonParser";
import MainContent1Title from "./MainContent1Title";
import AudioIcon, { useAutoPlayAudio, handleClickAudio } from "./Assets/AudioIcon";
import ConstantStrings from "../../constants/ConstantStrings";

const MainContent3Text = ({ data , isLast, playingAudioRef }) => {
    const content = data?.content;
    const text =
        content?.texts[0] !== null &&
        content?.texts[0] !== undefined &&
        content?.texts[0]?.length > 0
            ? jsonParser(content?.texts[0])
            : content?.texts[0];

    const audioLink = content?.audioLink;
    const audioRef = useRef(new Audio(ConstantStrings.IMAGE_URL + audioLink));
    const [isAudioPlaying, setIsAudioPlaying] = useState(false);

    useAutoPlayAudio({
        content,
        audioRef,
        playingAudioRef,
        setIsAudioPlaying,
        slideId: data?._id || data.questionId,
        type: 0
    });

    return (
        <div className="has-text-centered has-text-kurio-main-color-black">
            {!isLast && <ScrollRef />}
            {data?.title && 
                <MainContent1Title
                    title={data?.title} 
                    audioIcon={audioLink && playingAudioRef && <AudioIcon isPlaying={isAudioPlaying} onClick={() => handleClickAudio(audioRef, setIsAudioPlaying)} style={{marginBottom: '4px'}}/>}
                />
            }

            <BackgroundImageFromUrl
                objectId={content?.backgroundImage}
                className="content-text m-auto"
                style={{
                    maxWidth: "40rem",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "1rem",
                    fontSize: "1.25rem",
                }}
            >
                {text}
            </BackgroundImageFromUrl>
        </div>
    );
};

export default MainContent3Text;
